module.exports = __webpack_public_path__ + "img/profile-loyalty-card.daf9b75e.webp";